// extracted by mini-css-extract-plugin
module.exports = {"root":"QuestionsEditor-m__root___Zd0vA","borderless":"QuestionsEditor-m__borderless___Ofl0o","indent":"QuestionsEditor-m__indent___MimPR"};